// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type AppState } from '@advisor-app/store/store';
import { useAggregationData } from '@shared/advisory/aggregation/providers';
import { TickerTagFeature } from '@shared/data-access/interfaces/api/engine/citec';
import { selectAllTags } from '@shared/data-access/slices/tag-manager';
import { useTabsController } from '@shared/ui-kit';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';

export const useInvestment = () => {
  const {
    accountOptions,
    onChangeAccounts,
    selectedAccounts,
    onRefresh,
    status,
    updatedDate,
    currency,
    isSyncing,
    tags: tagsForSelector,
    tagsByObject,
    selectedTag,
    setSelectedTag,
  } = useAggregationData();

  const tags = useSelector((state: AppState) =>
    selectAllTags(state, TickerTagFeature.AggregatorPositions),
  );

  const [params, setParams] = useSearchParams();

  const tabsController = useTabsController(
    params.get('tab') ?? undefined,
    undefined,
    tab => {
      setParams({ tab: tab });
    },
    [params.get('tab')],
  );

  return {
    accountOptions,
    onChangeAccounts,
    selectedAccounts,
    onRefresh,
    status,
    tabsController,
    updatedDate,
    currency,
    tags,
    tagsForSelector,
    tagsByObject,
    selectedTag,
    setSelectedTag,
    isSyncing,
  };
};
